export interface DecodedJwt {
  _raw: string
  header: Record<string, unknown>
  payload: Record<string, unknown>
  signature: string
}

const PAYLOAD_NAMESPACE = 'https://access.dfh.dev/'

export const tokenPayloads = {
  customerId: `${PAYLOAD_NAMESPACE}ns_customer_id`,
  magentoUser: `${PAYLOAD_NAMESPACE}magento_user_group`,
  magentoUserGroup: `${PAYLOAD_NAMESPACE}magento_user`,
  customers: `${PAYLOAD_NAMESPACE}customers`,
  companyName: `${PAYLOAD_NAMESPACE}company_name`,
} as const

export function decodeJwt(token: string): DecodedJwt | undefined {
  const parts = token.split('.')

  if (parts.length !== 3) {
    console.warn(`Invalid JWT: does not contain 3 parts`)
    return
  }

  try {
    return {
      _raw: token,
      header: JSON.parse(atob(parts[0])),
      payload: JSON.parse(atob(parts[1])),
      signature: parts[2],
    }
  } catch (err) {
    console.warn('Invalid JWT: unable to parse:', err)
    return
  }
}
